import React, { useEffect, useRef, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { IMortgage } from '../../../../../../Interfaces/IMortgage';

interface IProps {
  handleBack: Function;
  handleNext: Function;
  mortgageObject: IMortgage;
  setMortgageObject: Function;
}

export const MortgageOptions: React.FC<IProps> = ({
  handleBack,
  handleNext,
  mortgageObject,
  setMortgageObject,
}) => {
  const formRef = useRef<HTMLFormElement>(null);
  const [existMortgage, setExistMortgage] = useState<boolean | null>(
    mortgageObject.ToBeDeleted
  );

  const handleSubmit = () => {
    setMortgageObject({
      ...mortgageObject,
    });
    handleNext();
  };
  const handleOnSave = () => {
    if (formRef.current && formRef.current.checkValidity()) {
      handleSubmit();
    } else if (formRef.current && !formRef.current.checkValidity()) {
      const elements = Array.from(formRef.current.elements).reverse();

      elements.forEach((element: any) => {
        if (element.reportValidity()) {
          element.reportValidity();
        }
      });
    }
  };
  const isFormValid = () => {
    if (formRef.current && formRef.current.checkValidity()) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    setMortgageObject({
      ...mortgageObject,
      ToBeDeleted: existMortgage,
    });
  }, [existMortgage]);

  return (
    <>
      <form ref={formRef}>
        <Box sx={{ mt: 6 }} />
        <Typography variant='h4'>Bestellen / Löschen</Typography>
        <Box sx={{ mt: 6 }} />
        <Box display='flex' flexDirection='column'>
          <Typography variant='body1' sx={{ mb: 2 }}>
            Soll eine bereits im Grundbuch eingetragene Grundschuld gelöscht
            (Option 1) oder eine neue Grundschuld im Grundbuch eingetragen
            (Option 2) werden?
          </Typography>
          <FormControl component='fieldset'>
            <RadioGroup
              value={
                existMortgage === null ? '' : existMortgage ? 'delete' : 'new'
              }
              onChange={e => setExistMortgage(e.target.value === 'delete')}
            >
              <Alert severity={'info'} icon={false} sx={{ mb: 2 }}>
                <FormControlLabel
                  value='delete'
                  control={<Radio required />}
                  label={
                    <Typography component='span'>
                      <u>
                        <b>Option 1:</b>
                      </u>{' '}
                      Es soll eine bereits im Grundbuch eingetragene Grundschuld
                      gelöscht werden.
                    </Typography>
                  }
                />
              </Alert>
              <Alert severity={'info'} icon={false}>
                <FormControlLabel
                  value='new'
                  control={<Radio required />}
                  label={
                    <Typography component='span'>
                      <u>
                        <b>Option 2:</b>
                      </u>{' '}
                      Es soll eine neue Grundschuld bestellt und im Grundbuch
                      eingetragen werden.
                    </Typography>
                  }
                />
              </Alert>
            </RadioGroup>
          </FormControl>
        </Box>

        <Box mt={6} sx={{ display: 'flex', flexDirection: 'row' }}>
          <Button
            variant='outlined'
            onClick={() => handleBack()}
            sx={{ mr: 1 }}
          >
            Zurück
          </Button>
          <Box sx={{ flex: '1 1 auto' }} />
          <Button
            onClick={() => {
              handleOnSave();
            }}
            variant={isFormValid() ? 'contained' : 'outlined'}
          >
            Weiter
          </Button>
        </Box>
      </form>
    </>
  );
};
